<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <organizer-selection
        v-model="innerValue"
        :error-messages="errors"
        :readonly="readonly"
        :label="label"
        :required-color="requiredColor"
        :required="required" />
  </ValidationProvider>
</template>

<script>
  import OrganizerSelection from './OrganizerSelection.vue'

  export default {
    components: {
      OrganizerSelection
    },
    props: {
      value: {
        type: String,
        default: null
      },
      rules: [String, Object],
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      },
      innerValue (val) {
        this.$emit('input', val)
        if (this.value !== val) {
          this.$emit('change', val)
        }
      }
    }
  }
</script>
